export function getLastOrder(source, key) {
  let objOrders = {};
  for (let i = source.length; i--;) {
    objOrders[source[i][key]] = null;
  }
  return Object.keys(objOrders).slice(-1).pop();
}

export function getItemByOrder(source, key, position) {
  for (let i = source.length; i--;) {
    if (source[i][key] == position) {
      return source[i];
    }
  }
  return null;
}

export function order(source, key) {
  const newArr = [];
  for (let i = source.length; i--;) {
    newArr[source[i][key]-1] = source[i];
  }
  return newArr;
}



// WEBPACK FOOTER //
// ./src/utils/order.js